"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-eighteen/section/blogSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type BlogSection126sItem = {
    key: Key | null | undefined;
    /** Detected variants: "1s" | "1.5s" | "2s" */
    dataWowDuration: string;
    /** Detected variants: "Pain Management" | "Nutrition" | "Mental Health" */
    a0Text: ReactNode;
    /** Detected variants: "5 Essential Stretches for Lower Back Pain Relief" | "Top 10 Superfoods to Boost Your Immune System" | "Meditation Techniques to Reduce Stress and Anxiety" */
    a0A0Text: ReactNode;
    /** Detected variants: "/Templates/Doccure/img/blog/blog-img-01.jpg" | "/Templates/Doccure/img/blog/blog-img-02.jpg" | "/Templates/Doccure/img/blog/blog-img-03.jpg" */
    src: string;
    /** Detected variants: "Grace Morgan" | "Liam Patel" | "Emily Chen" */
    a0A0Text2: ReactNode;
    /** Detected variants: "/Templates/Doccure/img/users/user-sm-1.jpg" | "/Templates/Doccure/img/users/user-sm-2.jpg" | "/Templates/Doccure/img/users/user-sm-3.jpg" */
    imageWithBasePath0Src: string;
    /** Detected variants: "15, Sep 2026" | "22, Oct 2026" | "05, Nov 2026" */
    p0Text: ReactNode;
    /** Detected variants: "Discover the most effective stretching exercises to alleviate lower back pain and improve flexibility. These evidence-based" | "Explore nutrient-rich foods that strengthen immunity and enhance overall health with simple diet tips backed by research." | "Learn proven meditation methods that promote mental clarity, emotional balance, and long-term stress reduction." */
    p0P0Text: ReactNode;
    /** Detected variants: "col-lg-12 col-md-6 d-flex" */
    className?: string;
    /** Detected variants: "blog-item-eighteen flex-fill wow fadeInUp" */
    div0ClassName?: string;
    /** Detected variants: "blog-tag" */
    a0ClassName?: string;
    /** Detected variants: "#" */
    href?: string;
    /** Detected variants: "blog-head" */
    div0ClassName2?: string;
    /** Detected variants: "#" */
    a0Href?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "blog-overlay" */
    div1ClassName?: string;
    /** Detected variants: "blog-img" */
    alt?: string;
    /** Detected variants: "img-fluid blog-img" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "blog-content" */
    div2ClassName?: string;
    /** Detected variants: "blog-info" */
    div0ClassName3?: string;
    /** Detected variants: "blog-author" */
    div0ClassName4?: string;
    /** Detected variants: "name" */
    a0ClassName2?: string;
    /** Detected variants: "#" */
    a0Href2?: string;
    /** Detected variants: "author-img" */
    div0ClassName5?: string;
    /** Detected variants: "user-img" */
    imageWithBasePath0Alt?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName2?: string;
    /** Detected variants: "date" */
    p0ClassName?: string;
    /** Detected variants: "description" */
    p0ClassName2?: string;
    /** Detected variants: "Read More" */
    a0A0Text3?: ReactNode;
    /** Detected variants: "theme-18-btn" */
    a0ClassName3?: string;
    /** Detected variants: "#" */
    a0Href3?: string;
    /** Detected variants: "icon" */
    span0ClassName?: string;
    /** Detected variants: "fa-solid fa-arrow-right" */
    i0ClassName?: string;
    /** Detected variants: "blog-link" */
    div1ClassName2?: string;
};
export type HomeEighteenBlogSectionGeneratedProps = {
    divDiv0Div0H30H3Props?: Partial<ComponentProps<"h3">> | ((item: BlogSection126sItem) => Partial<ComponentProps<"h3">>);
    divDiv0Div1ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BlogSection126sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div2Div0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BlogSection126sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    /** Default: "1s" */
    sectionDiv0Div0DivDataWowDuration?: string;
    /** Default: "Latest Insights & Tips" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "Expert Advice, Recovery Strategies" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    /** Default: "and Wellness Tips" */
    sectionDiv0Div0H20H2Text2?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "title" */
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/banner/title-img-6.jpg" */
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    sectionDiv0Div1ClassName?: string;
    blogSection126s: BlogSection126sItem[];
    blogSection126sItemWrapper?: (item: BlogSection126sItem, content: ReactNode) => ReactNode;
    blogSection126sRenderer?: (defaultNode: ReactNode) => ReactNode;
    blogSection126sImageVisible?: boolean;
    blogSection126sImageRenderer?: (item: BlogSection126sItem, defaultNode: ReactNode) => ReactNode;
    blogSection126sH3Visible?: boolean;
    blogSection126sH3Renderer?: (item: BlogSection126sItem, defaultNode: ReactNode) => ReactNode;
    blogSection126sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BlogSection126sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    blogSection126sH3Props?: Partial<ComponentProps<"h3">> | ((item: BlogSection126sItem) => Partial<ComponentProps<"h3">>);
};

const HomeEighteenBlogSectionGenerated: FC<HomeEighteenBlogSectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "Latest Insights & Tips",
    sectionDiv0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0H20H2Text = "Expert Advice, Recovery Strategies",
    sectionDiv0Div0H20H2Text2 = "and Wellness Tips",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageAlt = "title",
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/banner/title-img-6.jpg",
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageProps,
    divDiv0Div0H30H3Props,
    divDiv0Div1ImageWithBasePath0ImageProps,
    divDiv0Div2Div0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div1ClassName,
    blogSection126s,
    blogSection126sItemWrapper,
    blogSection126sRenderer,
    blogSection126sImageVisible,
    blogSection126sImageRenderer,
    blogSection126sH3Visible,
    blogSection126sH3Renderer,
    blogSection126sImageProps,
    blogSection126sH3Props,
}) => {
    return (
        <section className="section blog-section-eighteen">
            <div className="container">
                <div className="section-header-eighteen wow fadeInDown" data-wow-duration={sectionDiv0Div0DivDataWowDuration}>
                    <div className="sub-title">{sectionDiv0Div0Div0DivText}</div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>
                            {sectionDiv0Div0H20H2Text}
                            <br />
                            <span className="title-img">
                                {renderNode(sectionDiv0Div0H20Span0ImageWithBasePath0ImageVisible, sectionDiv0Div0H20Span0ImageWithBasePath0ImageRenderer, (
                                    <SmartImage src={sectionDiv0Div0H20Span0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0H20Span0ImageWithBasePath0ImageAlt} className="img-fluid" {...(sectionDiv0Div0H20Span0ImageWithBasePath0ImageProps ?? {})} />
                                ))}
                            </span>
                            {sectionDiv0Div0H20H2Text2}
                        </h2>
                    ))}
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row row-gap-4 justify-content-center"}>
                    {renderCollectionNode(
                        blogSection126s,
                        (item: BlogSection126sItem) => (
                            <div className={item.className ?? "col-lg-12 col-md-6 d-flex"} key={item.key}>
                                <div className={item.div0ClassName ?? "blog-item-eighteen flex-fill wow fadeInUp"} data-wow-duration={item.dataWowDuration}>
                                    <div className={item.div0ClassName2 ?? "blog-head"}>
                                        <a href={item.href ?? "#"} className={item.a0ClassName ?? "blog-tag"}>{item.a0Text}</a>
                                        {renderItemNode(blogSection126sH3Visible, blogSection126sH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof blogSection126sH3Props === "function" ? blogSection126sH3Props(item) : (blogSection126sH3Props ?? {}))} {...(typeof divDiv0Div0H30H3Props === "function" ? divDiv0Div0H30H3Props(item) : (divDiv0Div0H30H3Props ?? {}))}>
                                                <a href={item.a0Href ?? "#"}>{item.a0A0Text}</a>
                                            </h3>
                                        ))}
                                    </div>
                                    <div className={item.div1ClassName ?? "blog-overlay"}>
                                        {renderItemNode(blogSection126sImageVisible, blogSection126sImageRenderer, item, (
                                            <SmartImage src={item.src} alt={item.alt ?? "blog-img"} className={item.imageWithBasePath0ClassName ?? "img-fluid blog-img"} {...(typeof blogSection126sImageProps === "function" ? blogSection126sImageProps(item) : (blogSection126sImageProps ?? {}))} {...(typeof divDiv0Div1ImageWithBasePath0ImageProps === "function" ? divDiv0Div1ImageWithBasePath0ImageProps(item) : (divDiv0Div1ImageWithBasePath0ImageProps ?? {}))} />
                                        ))}
                                    </div>
                                    <div className={item.div2ClassName ?? "blog-content"}>
                                        <div className={item.div0ClassName3 ?? "blog-info"}>
                                            <p className={item.p0ClassName2 ?? "description"}>{item.p0P0Text}</p>
                                            <div className={item.div0ClassName4 ?? "blog-author"}>
                                                <div className={item.div0ClassName5 ?? "author-img"}>
                                                    {renderItemNode(blogSection126sImageVisible, blogSection126sImageRenderer, item, (
                                                        <SmartImage src={item.imageWithBasePath0Src} alt={item.imageWithBasePath0Alt ?? "user-img"} className={item.imageWithBasePath0ClassName2 ?? "img-fluid"} {...(typeof blogSection126sImageProps === "function" ? blogSection126sImageProps(item) : (blogSection126sImageProps ?? {}))} {...(typeof divDiv0Div2Div0Div0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div2Div0Div0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div2Div0Div0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                                    ))}
                                                    <a href={item.a0Href2 ?? "#"} className={item.a0ClassName2 ?? "name"}>{item.a0A0Text2}</a>
                                                </div>
                                                <p className={item.p0ClassName ?? "date"}>{item.p0Text}</p>
                                            </div>
                                        </div>
                                        <div className={item.div1ClassName2 ?? "blog-link"}>
                                            <a href={item.a0Href3 ?? "#"} className={item.a0ClassName3 ?? "theme-18-btn"}>
                                                {item.a0A0Text3 ?? "Read More"}
                                                <span className={item.span0ClassName ?? "icon"}>
                                                    <i className={item.i0ClassName ?? "fa-solid fa-arrow-right"}></i>
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ),
                        blogSection126sItemWrapper,
                        blogSection126sRenderer
                    )}
                </div>
            </div>
        </section>
    );
};

export default HomeEighteenBlogSectionGenerated;
